module.exports = __webpack_public_path__ + "img/golfpractice_bodyimage01.ad2711c4.jpg";